export const APP_DEFINITIONS = {
    'shopping-list': { label: 'Shopping List', icon: '🛒', color: 'bg-blue-500', path: '/shopping' },
    'language-learning': { label: 'Language Learning', icon: '📚', color: 'bg-green-500', path: '/learning' },
    'verb-trainer': { label: 'Verb Trainer', icon: '📝', color: 'bg-purple-500', path: '/verbs' },
    'vocabulary-trainer': { label: 'Vocabulary Trainer', icon: '🧠', color: 'bg-rose-500', path: '/vocabulary' },
    'admin': { label: 'Admin', icon: '⚙️', color: 'bg-gray-500', path: '/admin' },
};
export const DEFAULT_CATEGORIES = [
    { name: 'Food', icon: '🍎' },
    { name: 'Household', icon: '🏠' },
    { name: 'Cat', icon: '🐱' },
    { name: 'Hygiene', icon: '🧴' },
    { name: 'Other', icon: '📦' },
];
export const BOUGHT_TTL_DAYS = 3;
export const JWT_EXPIRY_DAYS = 7;
export const OPENAI_CACHE_TTL_DAYS = 30;
//# sourceMappingURL=constants.js.map